'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = UIFlex;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _Flex = require('../vendor/canvas/Flex');

var _Flex2 = _interopRequireDefault(_Flex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function UIFlex(props) {
  var align = props.align,
      alignSelf = props.alignSelf,
      children = props.children,
      className = props.className,
      direction = props.direction,
      justify = props.justify,
      wrap = props.wrap,
      rest = _objectWithoutProperties(props, ['align', 'alignSelf', 'children', 'className', 'direction', 'justify', 'wrap']);

  return _react2.default.createElement(
    _Flex2.default,
    _extends({}, rest, {
      align: align,
      alignSelf: alignSelf,
      className: (0, _reactUtils.classNames)('private-flex', className),
      direction: direction,
      justify: justify,
      wrap: wrap
    }),
    children
  );
}

UIFlex.propTypes = _extends({}, _Flex2.default.propTypes);
UIFlex.defaultProps = _extends({}, _Flex2.default.defaultProps);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1179/js/layout/UIFlex.js
// module id = 62
// module chunks = 0